import type { FC, ReactNode } from 'react'
import { useCallback, useMemo } from 'react'

import DropdownMenu from 'components/uiKit/DropdownMenu'
import type { IMenuOption } from 'components/uiKit/Menu'
import { testProps } from 'utils/test/qaData'

// Единый user-dropdown для публичного портала: header плеера (PlayerHeader),
// плавающий trigger при hideHeader (LiveCoursePlayer), header главной страницы
// портала (PortalLanding). Триггер задаётся через `children`, список действий —
// общий. Так гарантируем один и тот же паттерн логаута во всех трёх местах.
export type UserMenuAction = 'logout'

interface IUserMenuProps {
  onLogout: () => void
  children: ReactNode
  placement?: 'bottom-end' | 'bottom-start' | 'top-end' | 'top-start'
}

const UserMenu: FC<IUserMenuProps> = ({ onLogout, children, placement = 'bottom-end' }) => {
  const options = useMemo<IMenuOption<UserMenuAction>[]>(
    () => [{ value: 'logout', label: 'Logout' }],
    [],
  )

  const handleClick = useCallback(
    ({ value }: IMenuOption<UserMenuAction>) => {
      if (value === 'logout') {
        onLogout()
      }
    },
    [onLogout],
  )

  return (
    <DropdownMenu
      name='portalUserMenu'
      onClick={handleClick}
      options={options}
      placement={placement}
    >
      <span {...testProps({ el: 'dropdown', name: 'portalUserMenu' })}>{children}</span>
    </DropdownMenu>
  )
}

export default UserMenu
